import React, { useEffect, useState } from "react";
import Context from "../../../../context";

import {
  IItem,
  StatusInService,
  UpdateAbsent,
} from "../../../../types/common.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import { ABSENT_STATUS } from "../../../../values/dropdownItems";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import { useTranslation } from "react-i18next";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateFunction, isLoading, selectedAbsent } =
    React.useContext(Context.AbsentScreen);

  const [selectedStatus, setSelectedStatus] = useState<IItem>(
    selectedAbsent?.statusInService
  );

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const [textArea, setTextArea] = useState<string>("");

  useEffect(() => {
    setSelectedStatus(
      ABSENT_STATUS.find(
        (item) => item.value === selectedAbsent?.service?.statusInService
      ) as IItem
    );
    setTextArea(selectedAbsent?.description);
  }, []);
  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  async function submitHandler(formData: UpdateAbsent) {
    updateFunction(formData);
  }

  function closeHandler() {
    setShowModal("NONE");
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="super-agent-update-modal-container">
      <form>
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "UPDATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="user-information-container">
              <CustomView.Column medium={6}>
                <UserInformation
                  name={
                    selectedAbsent?.student?.firstName +
                    " " +
                    selectedAbsent?.student?.lastName
                  }
                  avatar={selectedAbsent?.student?.avatar}
                  phoneNumber={t("student")}
                />
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <UserInformation
                  name={
                    selectedAbsent?.driver?.firstName +
                    " " +
                    selectedAbsent?.driver?.lastName
                  }
                  avatar={selectedAbsent?.driver?.avatar}
                  phoneNumber={t("driver")}
                />
              </CustomView.Column>
            </CustomView.Row>
            <hr />
            <CustomView.Row className="form-row justify-center">
              <CustomView.Column medium={8} className="form-colum dropdown">
                <CustomCheckbox
                  label={t("changeServiceStatusQuestion")}
                  isChecked={isChecked}
                  onChecked={() => setIsChecked((prev) => !prev)}
                />
              </CustomView.Column>
              {isChecked && (
                <CustomView.Column medium={8} className="form-colum dropdown">
                  <label className="form-label">{t("serviceStatus")}</label>
                  <CustomDropdownSearch
                    items={ABSENT_STATUS?.map((item) => ({
                      ...item,
                      name: item.name,
                    }))}
                    itemName="name"
                    defaultItem={
                      selectedStatus
                        ? selectedStatus
                        : (ABSENT_STATUS.find(
                            (item) =>
                              item.value === selectedAbsent?.statusInService
                          ) as IItem)
                    }
                    onSelectItem={(event: any) => {
                      setSelectedStatus(event);
                    }}
                    placeHolder={t("selectServiceStatus")}
                    isLoading={false}
                  />
                </CustomView.Column>
              )}
              <CustomView.Column
                medium={8}
                className="form-colum dropdown description-input"
              >
                <label className="form-label">{t("description")}</label>
                <textarea
                  cols={33}
                  rows={3}
                  onChange={(e) => setTextArea(e.target.value)}
                >
                  {textArea}
                </textarea>
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={closeHandler}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() =>
                    submitHandler({
                      absentId: selectedAbsent?._id,
                      statusInService: selectedStatus?.value as StatusInService,
                      isChecked: true,
                      description: textArea,
                    })
                  }
                  title={t("update")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Update;
